const UTC_REGEX = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(?:\.?(\d{3}))?(?:(?:([-+]\d{2})(?::?(\d{2}))?)|Z)?)?$/;
export class Dataset {
    constructor(schema, data) {
        this._schema = schema;
        if (data == null) {
            this._data = [];
        }
        else {
            const dateColumns = new Array();
            for (const column of schema.columns) {
                switch (column.type) {
                    case 'DATE':
                    case 'DATETIME':
                        dateColumns.push(column.name);
                        break;
                }
            }
            if (dateColumns.length === 0) {
                this._data = data;
            }
            else {
                this._data = [];
                for (const datum of data) {
                    const row = {};
                    Object.assign(row, datum); // Copy Data
                    for (const columnName of dateColumns) {
                        let currValue = row[columnName];
                        if (typeof currValue === 'undefined') {
                            row[columnName] = null;
                        }
                        else {
                            if (typeof currValue === 'string') {
                                // FOR THE SPEEEEEED!!!
                                const dm = UTC_REGEX.exec(currValue);
                                if (dm) {
                                    const hourOffset = +dm[8] || 0;
                                    // Won't handle offsets between -00:01 to -00:59, but no countries use that range
                                    const minOffset = (+dm[9] || 0) * (hourOffset < 0 ? -1 : 1);
                                    // converts the time to UTC for consistent display
                                    currValue = Date.UTC(+dm[1], // year
                                    +dm[2] - 1, // month with JS offset
                                    +dm[3], // day
                                    +(dm[4] || 0) - hourOffset, // hour, if < 0 or >= 24 it will move the day
                                    +(dm[5] || 0) - minOffset, // min
                                    +(dm[6] || 0), // second
                                    +(dm[7] || 0)); // ms
                                }
                            }
                            if (currValue != null) {
                                row[columnName] = currValue;
                            }
                            else {
                                row[columnName] = null;
                            }
                        }
                    }
                    this._data.push(row);
                }
            }
        }
    }
    get schema() {
        return this._schema;
    }
    get data() {
        return this._data;
    }
    get size() {
        return this.data.length;
    }
    get(rowNumber) {
        return this.data[rowNumber];
    }
    getRows(rowNums, filterFn) {
        const result = new Array();
        if (filterFn == null) {
            for (const rowNum of rowNums) {
                result.push(this.get(rowNum));
            }
        }
        else {
            for (const rowNum of rowNums) {
                const row = this.get(rowNum);
                if (filterFn(row)) {
                    result.push(row);
                }
            }
        }
        return result;
    }
    eachRow(rowFn, filterFn) {
        if (filterFn == null) {
            for (const row of this.data) {
                rowFn(row);
            }
        }
        else {
            for (const row of this.data) {
                if (filterFn(row)) {
                    rowFn(row);
                }
            }
        }
    }
    getValue(rowNumber, columnName) {
        const row = this.get(rowNumber);
        return this.get(rowNumber)[columnName];
    }
    eachValue(columnName, rowFn, filterFn) {
        if (filterFn == null) {
            for (const row of this.data) {
                rowFn(row[columnName]);
            }
        }
        else {
            for (const row of this.data) {
                if (filterFn(row)) {
                    rowFn(row[columnName]);
                }
            }
        }
    }
    /**
     * Utility Functions
     */
    getKey(row, fieldNames) {
        const key = new Array();
        for (const fieldName of fieldNames) {
            key.push(row[fieldName]);
        }
        return key.join('|');
    }
    getKeyCount(fieldNames) {
        const keys = new Set();
        for (const row of this.data) {
            keys.add(this.getKey(row, fieldNames));
        }
        return keys.size;
    }
    getKeyCombinations(fieldNames) {
        const sets = new Array();
        fieldNames.forEach((f) => {
            sets.push(new Set());
        });
        for (const row of this.data) {
            fieldNames.forEach((fieldName, i) => {
                sets[i].add(row[fieldName]);
            });
        }
        const values = sets.map((set) => Array.from(set));
        return values.reduce((a, b) => {
            return a
                .map((x) => {
                return b.map((y) => {
                    return x.concat(y);
                });
            })
                .reduce((w, z) => w.concat(z), []);
        }, [[]]);
    }
}
